/* eslint-disable */
import { DataType, Middleware } from "@sa/rep-common";
import { DataFlowProcessingState, MultiValueParameter, ParameterBase, SingleValueParameter } from "@sa/rep-core";
import { DictionariesService, DictionaryItem } from "@sa/rep-mdm";
import { ServiceProvider } from "@sa/rep-services-provider";
import { arrayByLength } from "../../../../../shared";
import { ServicesRegister } from "../../../shared";
import { REPORT_ID } from '../constants';

export const slide23DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  const dictionariesServices = serviceProvider.resolve<DictionariesService>(ServicesRegister.Dictionary);
  return (async function (input, next) {
    if ([REPORT_ID].includes(input.reportId)) {
      
    }
    return next(input);
  }) as Middleware<DataFlowProcessingState>
};  
